/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Duration_One_LinerInputs */

const en_exp_duration_one_liner = /** @type {(inputs: Exp_Duration_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A rough stress estimate from session duration alone — for sessions without heart rate data and rides without power.`)
};

const de_exp_duration_one_liner = /** @type {(inputs: Exp_Duration_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grobe Belastungsschätzung nur aus der Dauer — für Einheiten ohne HF-Daten und Radfahrten ohne Leistung.`)
};

/**
* | output |
* | --- |
* | "A rough stress estimate from session duration alone — for sessions without heart rate data and rides without power." |
*
* @param {Exp_Duration_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_duration_one_liner = /** @type {((inputs?: Exp_Duration_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Duration_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_duration_one_liner(inputs)
	return de_exp_duration_one_liner(inputs)
});